module.exports = __webpack_public_path__ + "img/step3-img.6314267f.png";